import type { ShopProvider } from '@/lib/api/shop-account-api'
import { m } from '@/lib/paraglide/messages'

/** Tên cách đăng nhập của tài khoản khách bán lẻ. */
export const PROVIDER_LABEL: Record<ShopProvider, () => string> = {
    email: () => m.shop_account_provider_email(),
    google: () => m.shop_account_provider_google(),
    zalo: () => m.shop_account_provider_zalo(),
    phone: () => m.shop_account_provider_phone(),
}

/**
 * Nhãn cách đăng nhập; mã lạ (ERP mới hơn bản app đang chạy, PWA chưa tải lại)
 * hiện nguyên mã thay vì làm vỡ trang.
 */
export function providerLabel(provider: string): string {
    const label = (PROVIDER_LABEL as Partial<Record<string, () => string>>)[
        provider
    ]
    return label ? label() : provider
}
